import { ChatSettingsRoute } from '@pwa/components/chat/chat-settings-route';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId/c/$chatId/settings')({
	component: ClientChatSettingsRoute,
	validateSearch: (_search: Record<string, unknown>) => ({}),
});

function ClientChatSettingsRoute() {
	const { chatId, wsId, orgId } = Route.useParams();
	return <ChatSettingsRoute chatId={chatId} workspaceId={wsId} orgId={orgId} />;
}
